import { render, staticRenderFns } from "./AddInner.vue?vue&type=template&id=2922e38b&scoped=true&"
import script from "./AddInner.vue?vue&type=script&lang=js&"
export * from "./AddInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922e38b",
  null
  
)

export default component.exports